import React from "react";

import { Link } from "react-router-dom";
import Typography from "@mui/material/Typography";

interface BaseLinkProps {
    link: string;
    label: string;
}

const BaseLink = (props: BaseLinkProps) => {
    const { link, label } = props;
    return (
        <Link to={link} style={{ textDecoration: "none" }}>
            <Typography variant="body2">{label}</Typography>
        </Link>
    );
};

export const HomeLink = () => <BaseLink link="/home" label="HOME" />;
export const InformationLink = () => <BaseLink link="/information" label="お知らせ" />;
